var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisk = function SvgDisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M7.47 6.5a.75.75 0 0 0-.585.281L2.31 12.5H9a.75.75 0 0 1 .75.75 2.25 2.25 0 0 0 4.5 0 .75.75 0 0 1 .75-.75h6.69l-4.575-5.719a.75.75 0 0 0-.586-.281zM22.4 14h-6.725a3.751 3.751 0 0 1-7.35 0H1.6l.48 3.843a.75.75 0 0 0 .744.657h18.352a.75.75 0 0 0 .744-.657zM5.714 5.844A2.25 2.25 0 0 1 7.471 5h9.058c.684 0 1.33.31 1.757.844l5.55 6.937a.75.75 0 0 1 .158.562l-.585 4.686A2.25 2.25 0 0 1 21.176 20H2.824a2.25 2.25 0 0 1-2.232-1.97l-.586-4.687a.75.75 0 0 1 .158-.562z"
  })));
};
export default SvgDisk;